let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("axyb1")).then(() => parcelRequire('3chUb'));